export const projectsData = [
  {
    "id": "safana-ai-chatbot",
    "title": "Safana AI Chatbot",
    "shortDesc": "Enterprise AI Customer Support Platform",
    "programType": "Delivered Program",
    "role": "Lead Architect / Multi-Agent AI Platform Owner",
    "impact": "Built an enterprise AI support layer that reduced manual support cost and accelerated resolution cycles through agentic orchestration, RAG, and live enterprise integrations.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Deep",
      "modernTech": "Cutting edge"
    },
    "overview": "Designed and led an enterprise-grade customer support platform that combined LLM-driven conversations, intent routing, enterprise tool access, and contextual retrieval into a single production-oriented support architecture.",
    "scaleComplexity": "High-volume support operations with real-time conversational response handling and enterprise API integrations.",
    "architectureTech": "",
    "tech": [
      "FastAPI",
      "Python",
      "LangChain",
      "OpenAI stack",
      "Kafka",
      "Redis",
      "Docker",
      "Kubernetes",
      "REST integrations",
      "vector retrieval/RAG"
    ],
    "outcomes": [
      "Designed multi-agent flow for intent detection, routing, tool invocation, and response synthesis.",
      "Implemented retrieval-augmented grounding to reduce hallucination risk on enterprise knowledge tasks.",
      "Integrated live backend systems so the bot could fetch transaction, account, or service data when needed.",
      "Optimized latency with caching, async processing, and separation of low-latency vs heavy-compute flows. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Agentic AI, RAG, enterprise tool-use, AI operations pattern.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "etv-bharat",
    "title": "ETV Bharat",
    "shortDesc": "Nationwide Digital News Platform Modernization",
    "programType": "Delivered Program",
    "role": "Architect / Platform Modernization Lead",
    "impact": "Modernized a large digital news ecosystem from monolithic foundations toward a cloud-native, event-driven, multi-service architecture built for scale, speed, and editorial agility.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Very large",
      "architecture": "Deep",
      "modernTech": "AI-ready"
    },
    "overview": "Led architecture and modernization work for a high-traffic digital news platform serving multiple audiences, regions, and content flows, with emphasis on delivery performance, editorial throughput, and platform resiliency.",
    "scaleComplexity": "10M+ user scale, 30+ service components, high-volume content ingestion and delivery across multiple editorial workflows.",
    "architectureTech": "",
    "tech": [
      "Node.js",
      "Kafka",
      "AWS",
      "Kubernetes",
      "CloudFront",
      "Elasticsearch/OpenSearch patterns",
      "API integrations",
      "observability stack"
    ],
    "outcomes": [
      "Drove monolith-to-microservices modernization for a platform with demanding content velocity.",
      "Designed content ingestion and event flows to support real-time publishing and distribution.",
      "Strengthened CDN, caching, and edge-delivery patterns for better user experience at scale.",
      "Established architectural direction that improved service isolation, resilience, and maintainability. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Event-driven media architecture, cloud-native scalability, observability-first design.",
    "radar": [
      {
        "subject": "Scale",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "hospital-online-appointment-booking-system",
    "title": "Hospital Online Appointment Booking System",
    "shortDesc": "Hospital Online Appointment Booking System",
    "programType": "Delivered Program",
    "role": "Solution Architect / One-Man Architect",
    "impact": "Created a patient-facing digital booking experience that reduced manual dependency and improved appointment accessibility for a large oncology care environment.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Designed and delivered an online appointment platform to streamline booking, scheduling, and patient access flows in a high-sensitivity hospital environment.",
    "scaleComplexity": "Large hospital patient volume with daily appointment traffic and operational dependence on reliable scheduling.",
    "architectureTech": "",
    "tech": [
      "Web application stack",
      "APIs",
      "hospital system integration patterns",
      "SMS/notification flows",
      "secure patient workflow design"
    ],
    "outcomes": [
      "Defined end-to-end booking journey from discovery and slot selection to confirmation and follow-up.",
      "Designed integration points with hospital-side scheduling and patient records workflows.",
      "Balanced usability with operational constraints typical in high-volume hospital environments.",
      "Provided architecture ownership from concept to implementation direction. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Digital patient access, self-service healthcare workflow, integrated notification journeys.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "hospital-token-and-queue-management-system",
    "title": "Hospital Token and Queue Management System",
    "shortDesc": "Hospital Token and Queue Management System",
    "programType": "Delivered Program",
    "role": "Solution Architect / Patient Flow Systems Lead",
    "impact": "Digitized queue orchestration and patient movement visibility, improving outpatient flow and reducing confusion in a busy hospital setting.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Built a queue and token management system to manage patient movement, department coordination, token issuance, and waiting status visibility.",
    "scaleComplexity": "Hospital-wide operational use with high dependency on predictable throughput and department-level coordination.",
    "architectureTech": "",
    "tech": [
      "Web/mobile interfaces",
      "backend APIs",
      "operational dashboards",
      "display integrations",
      "workflow logic",
      "notification triggers"
    ],
    "outcomes": [
      "Modeled patient token lifecycle across registration, waiting, calling, and completion stages.",
      "Designed operational screens and status-driven rules to match real hospital ground workflows.",
      "Enabled visibility for staff and patients through digital displays and queue state management.",
      "Built a reusable operational pattern for other patient self-service systems. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Operational workflow digitization, service design for physical operations, real-time status visibility.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "hospital-vaccination-management-system",
    "title": "Hospital Vaccination Management System",
    "shortDesc": "Hospital Vaccination Management System",
    "programType": "Delivered Program",
    "role": "Solution Architect",
    "impact": "Enabled streamlined vaccination workflow management with digital tracking across registration, queueing, and service completion stages.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Current"
    },
    "overview": "Designed a vaccination workflow platform to support organized patient intake, eligibility/status tracking, and operational coordination within hospital service environments.",
    "scaleComplexity": "Operational healthcare deployment supporting process reliability, traceability, and throughput.",
    "architectureTech": "",
    "tech": [
      "Application workflow stack",
      "APIs",
      "operational dashboards",
      "patient communication modules",
      "reporting and audit views"
    ],
    "outcomes": [
      "Defined core operational flows for registration, processing, service delivery, and completion tracking.",
      "Designed visibility points for staff to monitor status and throughput across the service chain.",
      "Created architecture suitable for policy/process change without major platform rework.",
      "Supported a reliable, auditable digital service model in a healthcare setting. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Workflow digitization, healthcare service orchestration, auditable process design.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 75,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "hospital-health-bot",
    "title": "Hospital Health Bot",
    "shortDesc": "Patient Experience and Self-Service Layer",
    "programType": "Delivered / Expansion Initiative",
    "role": "AI Solution Architect",
    "impact": "Extended hospital self-service beyond forms and counters by introducing conversational access for patient support, information guidance, and journey assistance.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Cutting edge"
    },
    "overview": "Designed AI-driven health bot capabilities to improve patient experience, triage information access, and guided self-service inside the hospital ecosystem.",
    "scaleComplexity": "Patient-facing hospital support use cases across information, guidance, and journey assistance.",
    "architectureTech": "",
    "tech": [
      "Conversational AI patterns",
      "APIs",
      "workflow engines",
      "content retrieval",
      "hospital integration design",
      "chatbot orchestration"
    ],
    "outcomes": [
      "Designed chatbot use-case hierarchy for informational, assistive, and workflow-driven interactions.",
      "Mapped escalation logic from automated guidance to staff-assisted support where needed.",
      "Aligned bot behavior with hospital communication sensitivity and operational realities.",
      "Created a foundation for future AI-led patient interaction patterns. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Healthcare AI assistants, guided self-service, conversational workflow integration.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "hospital-kiosk-self-service-platform",
    "title": "Hospital Kiosk Self-Service Platform",
    "shortDesc": "Hospital Kiosk Self-Service Platform",
    "programType": "Delivered / Expansion Initiative",
    "role": "Digital Patient Experience Architect",
    "impact": "Introduced physical-digital self-service touchpoints that reduced front-desk dependence and improved patient autonomy on premises.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected kiosk-driven self-service for patient transactions and guided workflows inside the hospital, with focus on intuitive UX and operational compatibility.",
    "scaleComplexity": "On-premise hospital usage with direct influence on patient convenience and staff load distribution.",
    "architectureTech": "",
    "tech": [
      "Kiosk software design",
      "APIs",
      "workflow engines",
      "hospital integration",
      "touch UI design",
      "peripheral-friendly architecture"
    ],
    "outcomes": [
      "Designed user journeys for quick self-service in a high-stress healthcare environment.",
      "Aligned kiosk functionality with operational processes rather than building a disconnected UI layer.",
      "Created architecture that could support additional services over time without redesign.",
      "Balanced usability, security, and integration practicality for on-premise deployment. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Phygital service design, self-service touchpoint architecture, patient experience modernization.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "interactive-signbots-for-patient-education-and-awareness",
    "title": "Interactive SignBots for Patient Education and Awareness",
    "shortDesc": "Interactive SignBots for Patient Education and Awareness",
    "programType": "Innovation Initiative",
    "role": "Experience Architect",
    "impact": "Moved static awareness content into interactive digital experiences to improve engagement and information access within the hospital environment.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Growing",
      "architecture": "Distributed",
      "modernTech": "Cloud-native"
    },
    "overview": "Designed touchscreen-based interactive signbots to educate and guide patients using accessible, attention-friendly content experiences on premises.",
    "scaleComplexity": "Hospital-wide awareness and education touchpoints with repeat-use public-facing deployment.",
    "architectureTech": "",
    "tech": [
      "Touchscreen UI design",
      "content systems",
      "experience workflow design",
      "interactive display integration"
    ],
    "outcomes": [
      "Translated awareness objectives into interactive, easy-to-consume digital journeys.",
      "Designed flexible content architecture to support campaigns, updates, and topic variations.",
      "Made experience design suitable for diverse patient demographics and usage comfort levels.",
      "Expanded digital engagement beyond transactional systems into educational interaction. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Interactive digital experiences, assisted education touchpoints, UX-led service environments.",
    "radar": [
      {
        "subject": "Scale",
        "A": 80,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 80,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "docty",
    "title": "Docty",
    "shortDesc": "Global Telemedicine and Digital Health Platform",
    "programType": "Delivered Program",
    "role": "Global CTO / Platform and Growth Leader",
    "impact": "Led large-scale telemedicine platform engineering and growth across India and international markets, combining product, technology, doctor onboarding, and service scalability.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Very large",
      "architecture": "Deep",
      "modernTech": "AI-ready"
    },
    "overview": "Owned global technology and India growth responsibilities for a telemedicine ecosystem spanning consultations, doctor networks, patient journeys, and healthcare partnerships.",
    "scaleComplexity": "National and international telemedicine operations with multi-geo deployment considerations and broad stakeholder coordination.",
    "architectureTech": "",
    "tech": [
      "Cloud-native healthcare platform stack",
      "APIs",
      "mobile/web apps",
      "partner integrations",
      "operational dashboards",
      "video/consultation workflows"
    ],
    "outcomes": [
      "Led platform evolution across patient, doctor, and operational experience layers.",
      "Aligned technology choices with healthcare growth, partnerships, and service operations.",
      "Managed architecture direction while also contributing to growth-oriented execution.",
      "Built reusable patterns from multiple telemedicine implementations over several years. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Digital health platforms, telemedicine scale-up, product plus growth technology leadership.",
    "radar": [
      {
        "subject": "Scale",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "ur.life",
    "title": "UR.Life",
    "shortDesc": "Content, Commerce, and Subscription Platform",
    "programType": "Delivered Program",
    "role": "Group CTO / Platform Owner",
    "impact": "Built and scaled a content-led digital platform with commerce, personalization, subscriptions, and COVID-era acceleration under Apollo group leadership.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Deep",
      "modernTech": "Cloud-native"
    },
    "overview": "Initiated and led the UR.Life portal as a blended content and e-commerce experience, combining publishing, subscriptions, personalization, and digital product growth.",
    "scaleComplexity": "Consumer-facing digital platform with content and commerce workloads, accelerated during a period of heightened digital demand.",
    "architectureTech": "",
    "tech": [
      "PHP stack",
      "content platform architecture",
      "personalization concepts",
      "subscription flows",
      "SEO systems",
      "vendor and integration management"
    ],
    "outcomes": [
      "Drove architecture, delivery, and vendor coordination for the full portal initiative.",
      "Designed the platform to balance editorial flexibility with commercial capabilities.",
      "Focused on growth levers such as subscriptions, personalization, and SEO visibility.",
      "Owned platform evolution as a business capability rather than a pure technology build. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Content-commerce convergence, digital subscriptions, personalization-led product design.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "bpositive-magazine",
    "title": "BPositive Magazine",
    "shortDesc": "Custom CMS to WordPress Digital Transformation",
    "programType": "Delivered Program",
    "role": "Group CTO / Media Digitization Lead",
    "impact": "Converted a print-oriented content operation into a digitally managed e-magazine and content distribution model using a modern CMS backbone.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Led the migration from a custom CMS approach to a WordPress-centered digital content ecosystem, enabling magazine digitization and better downstream consumption.",
    "scaleComplexity": "Editorial and media operations with recurring content publishing and digital distribution requirements.",
    "architectureTech": "",
    "tech": [
      "WordPress",
      "custom CMS migration",
      "editorial workflow design",
      "content hub architecture",
      "MEAN-stack consumption patterns"
    ],
    "outcomes": [
      "Designed the transition path from custom CMS processes to a more scalable WordPress-centered model.",
      "Aligned editorial workflows with digital-first publishing needs.",
      "Enabled WordPress to act as a durable content backbone for broader user experiences.",
      "Balanced CMS flexibility, usability, and operational practicality for media teams. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Headless/hub-style CMS thinking, editorial workflow modernization, digital media transformation.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "mobizz",
    "title": "Mobizz",
    "shortDesc": "Mobile Commerce Platform for Local Discovery and Transactions",
    "programType": "Delivered Program",
    "role": "Founding Engineer / Technical Product Manager",
    "impact": "Built a WhatsApp-plus-JustDial style mobile commerce platform from scratch as the first engineering employee, covering backend, apps, payments, and infrastructure.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Deep",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected and helped build a commerce/discovery platform that combined business discovery, transactions, mobile experiences, and real production delivery from zero to launch.",
    "scaleComplexity": "Production mobile commerce system with consumer-facing flows and partner/service integration requirements.",
    "architectureTech": "",
    "tech": [
      "Node.js",
      "MEAN stack",
      "MongoDB",
      "Express",
      "Angular",
      "AWS",
      "Android",
      "iOS",
      "payment gateway integration",
      "SMS integration"
    ],
    "outcomes": [
      "Built core backend and mobile architecture for a platform with multiple transaction paths.",
      "Integrated key ecosystem services including payments and messaging."
    ],
    "businessOutcome": "",
    "trendingTechLens": "",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "sooper-lms",
    "title": "SOOPER LMS",
    "shortDesc": "Multi-Tenant Learning Platform",
    "programType": "Delivered / Product Initiative",
    "role": "Product Architect",
    "impact": "Designed a scalable learning platform for structured education delivery, content access, user-role management, and future extensibility across tenants.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected an LMS platform to support modern e-learning journeys, content management, learner access, and institution-ready multi-tenant capabilities.",
    "scaleComplexity": "Institution-facing deployment model designed for multiple user roles and tenant expansion.",
    "architectureTech": "",
    "tech": [
      "MEAN stack patterns",
      "cloud deployment",
      "content/video integration",
      "role-based workflows",
      "reporting/analytics modules"
    ],
    "outcomes": [
      "Defined multi-role experience flows for learners, instructors, and administrators.",
      "Designed platform boundaries for content, access, progress, and reporting functions.",
      "Planned for tenantability and future product evolution rather than a narrow one-off build.",
      "Balanced product simplicity with enterprise-style extensibility. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "EdTech platform design, multi-tenant SaaS thinking, modular learning workflow architecture.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "education-communication-platform",
    "title": "Education Communication Platform",
    "shortDesc": "WhatsApp-Like Messaging for Schools and Institutions",
    "programType": "Delivered / Architecture Program",
    "role": "Solution Architect",
    "impact": "Designed a real-time communication system tailored for educational institutions, combining messaging-style usability with role-based governance and deployment flexibility.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected a communication platform for schools, colleges, and institution groups, with emphasis on role-driven messaging, groups, and scalable operational support.",
    "scaleComplexity": "Institution-wide communication use cases with repeatable deployment across educational entities.",
    "architectureTech": "",
    "tech": [
      "Node.js",
      "WebSocket/real-time messaging patterns",
      "Redis",
      "APIs",
      "mobile/web app architecture",
      "notification systems"
    ],
    "outcomes": [
      "Modeled messaging rules and role boundaries suitable for education environments.",
      "Designed for repeatable deployment across schools and grouped institutions.",
      "Balanced user familiarity with operational controls and moderation needs.",
      "Produced deep technical and architectural analysis for production-oriented execution. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Real-time communication platforms, role-aware collaboration systems, repeatable multi-tenant rollout design.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "content-publisher-performance-engineering-and-cdn-modernization",
    "title": "Content Publisher Performance Engineering and CDN Modernization",
    "shortDesc": "Content Publisher Performance Engineering and CDN Modernization",
    "programType": "Delivered Program",
    "role": "Performance and Platform Architect",
    "impact": "Analyzed and improved a large content site's performance after CDN migration impact, focusing on page types, cache strategy, and user experience recovery.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Deep",
      "modernTech": "Current"
    },
    "overview": "Led performance tuning analysis for a major content publisher covering home, category, article, and media-rich page types, especially after Akamai-to-CloudFront migration issues.",
    "scaleComplexity": "High-traffic news/content environment with heavy media and repeated page-view patterns.",
    "architectureTech": "",
    "tech": [
      "AWS CloudFront",
      "web performance engineering",
      "caching strategy",
      "content publishing stacks",
      "diagnostics and tuning methods"
    ],
    "outcomes": [
      "Decomposed performance issues by page archetype instead of using one-size-fits-all assumptions.",
      "Reviewed CDN behavior, origin interactions, and cache-control effectiveness.",
      "Connected technical performance degradation to audience and business impact.",
      "Provided architecture-level remedies rather than superficial tuning tips. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Performance engineering, CDN strategy, user-experience-sensitive platform optimization.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 75,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "news-publishing-platform",
    "title": "News Publishing Platform",
    "shortDesc": "JSON in S3, Metadata in MySQL, Search-Driven Experience",
    "programType": "Delivered / Architecture Program",
    "role": "Data and Search Platform Architect",
    "impact": "Designed a publishing architecture that separated article payload storage, metadata indexing, and search experience for scalable news operations.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected a content platform where article bodies are stored as JSON documents in S3 while metadata and filter/search control are handled separately for web delivery and discovery.",
    "scaleComplexity": "Publisher-scale structured content management with search and filtering as critical user experience layers.",
    "architectureTech": "",
    "tech": [
      "AWS S3",
      "MySQL",
      "search engine architecture",
      "content APIs",
      "filtering design",
      "publishing workflow integration"
    ],
    "outcomes": [
      "Defined the object-storage plus metadata-index split for flexible content operations.",
      "Designed the search model around user interaction rather than simple keyword retrieval.",
      "Aligned platform structure with publishing, filtering, and website delivery needs.",
      "Created an architecture that supports future scaling and index evolution. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Content payload decoupling, search-centric publishing systems, cloud-native storage architecture.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "shopify-odoo-middleware-platform",
    "title": "Shopify-Odoo Middleware Platform",
    "shortDesc": "Shopify-Odoo Middleware Platform",
    "programType": "Current Build / Productized Integration",
    "role": "Technical Architect / Integration Owner",
    "impact": "Built a production-grade middleware design to synchronize commerce activity with ERP operations, using Odoo as inventory master and automation around order and invoice flow.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Enterprise",
      "architecture": "Deep",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected a middleware platform to bridge Shopify storefront operations with Odoo ERP workflows while preserving inventory truth, order synchronization, and finance-linked processes.",
    "scaleComplexity": "Business-critical commerce-to-ERP operations where correctness, timing, and reconciliation matter more than simple data transfer.",
    "architectureTech": "",
    "tech": [
      "Python",
      "Odoo",
      "Shopify APIs",
      "Docker",
      "middleware patterns",
      "webhooks",
      "sync engines",
      "AWS deployment planning"
    ],
    "outcomes": [
      "Defined Odoo as source of truth for inventory and aligned sync logic to that model.",
      "Designed order and invoice workflow synchronization with failure-handling considerations.",
      "Built the system for local containerized testing before cloud deployment.",
      "Focused on durable integration design instead of brittle point-to-point scripting. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Composable commerce, ERP-commerce middleware, webhook-driven synchronization architecture.",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "cherrydesk",
    "title": "CherryDesk",
    "shortDesc": "AI-Assisted IT Helpdesk Platform",
    "programType": "Product Initiative",
    "role": "Product and Solution Architect",
    "impact": "Architected a multi-vertical super-app and marketplace ecosystem for parents and kids, spanning shopping, activities, education, services, community, and creator monetization.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Very large",
      "architecture": "Deep",
      "modernTech": "AI-ready"
    },
    "overview": "Designed the ecosystem architecture for a broad marketplace product with multiple verticals, partner extensibility, merchandising/search needs, loyalty, wallet, subscriptions, and rich commerce journeys.",
    "scaleComplexity": "Large multi-vertical consumer platform intended for phased rollout with commerce, content, booking, community, and partner integrations.",
    "architectureTech": "",
    "tech": [
      "Node.js/commerce platform patterns",
      "search/merchandising",
      "marketplace architecture",
      "wallets",
      "loyalty",
      "notifications",
      "AI chatbot support",
      "scalable APIs"
    ],
    "outcomes": [
      "Defined the helpdesk operating model around workflows, SLA logic, and usability.",
      "Introduced AI opportunities for ticket classification, support assist, and guided response.",
      "Built product framing suitable for demos, proposals, and commercial positioning.",
      "Balanced operational realism with product differentiation goals. | Business outcome & hiring signal",
      "Defined ecosystem modules across shopping, activities, services, education, and influencer-led monetization.",
      "Modeled marketplace complexity including catalog, search, bundles, wallets, rewards, and subscriptions.",
      "Planned phased delivery to reduce implementation risk while keeping long-term platform coherence.",
      "Designed the platform as an ecosystem, not a single-feature storefront. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Marketplace super-app design, ecosystem commerce, search-and-merchandising-led growth architecture.",
    "radar": [
      {
        "subject": "Scale",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "deploymetrix",
    "title": "DeployMetrix",
    "shortDesc": "AI-Powered Deployment and Ops Platform",
    "programType": "Product Initiative",
    "role": "Creator / Platform Architect",
    "impact": "Conceived a self-service deployment and observability platform to simplify multi-app hosting, deployment, monitoring, and operational insight for modern teams.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cutting edge"
    },
    "overview": "Designed a platform vision for streamlined application deployment, reverse proxying, monitoring, logging, and AI-assisted operational productivity.",
    "scaleComplexity": "Platform intended to manage multiple applications/environments with operational clarity and simplified deployment workflows.",
    "architectureTech": "",
    "tech": [
      "Docker",
      "Docker Compose",
      "Traefik/Caddy patterns",
      "Prometheus",
      "Grafana",
      "Loki",
      "SigNoz/OpenTelemetry concepts",
      "AI-assisted DevOps ideas"
    ],
    "outcomes": [
      "Defined the platform around practical deployment friction points instead of abstract platform buzzwords.",
      "Combined deployment automation with observability thinking from the start.",
      "Structured the product to support self-hosting and operational transparency.",
      "Created a clear product narrative around AI-enabled DevOps productivity. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Platform engineering, self-hosted PaaS patterns, observability-first ops, AI-enabled DevOps.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "knowledge-graph---rag-demo-platform",
    "title": "Knowledge Graph + RAG Demo Platform",
    "shortDesc": "Knowledge Graph + RAG Demo Platform",
    "programType": "Current Technical Showcase",
    "role": "AI/ML Solution Architect",
    "impact": "Built a modern AI showcase combining retrieval, graph-aware reasoning, API delivery, and optional vector database integrations to demonstrate practical GenAI architecture depth.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Enterprise",
      "architecture": "Advanced",
      "modernTech": "Cutting edge"
    },
    "overview": "Created an applied GenAI architecture demonstration that connects vector retrieval, graph pruning, API-based access, and front-end consumption patterns.",
    "scaleComplexity": "",
    "architectureTech": "",
    "tech": [],
    "outcomes": [],
    "businessOutcome": "",
    "trendingTechLens": "",
    "radar": [
      {
        "subject": "Scale",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "created-an-applied-genai-architecture-demonstration-that-connects-vector-retrieval,-graph-pruning,-api-based-access,-and-front-end-consumption-patterns.",
    "title": "Created an applied GenAI architecture demonstration that connects vector retrieval, graph pruning, API-based access, and front-end consumption patterns.",
    "shortDesc": "Created an applied GenAI architecture demonstration that connects vector retrieval, graph pruning, API-based access, and front-end consumption patterns.",
    "programType": "Scale & complexity: Showcase and prototype context focused on explainability, modular architecture, and extensible deployment paths.",
    "role": "Architecture & technology",
    "impact": "",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "Cutting edge"
    },
    "overview": "",
    "scaleComplexity": "",
    "architectureTech": "",
    "tech": [
      "Python",
      "FastAPI",
      "FAISS",
      "Pinecone-style integration",
      "knowledge graph logic",
      "vector search",
      "React/Streamlit",
      "Docker"
    ],
    "outcomes": [
      "Connected graph-logic pruning with retrieval to improve precision and explainability.",
      "Designed both API-first and UI-consumable variants for flexible demos.",
      "Planned containerization, HTTPS, CI/CD, and deployment routes to show production awareness.",
      "Used the project as a showcase of practical RAG systems thinking rather than generic chatbot packaging. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "RAG, vector databases, graph-aware retrieval, API-first GenAI architecture.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "ai-powered-cms-and-wordpress-centric-content-operations",
    "title": "AI-Powered CMS and WordPress-Centric Content Operations",
    "shortDesc": "AI-Powered CMS and WordPress-Centric Content Operations",
    "programType": "Showcase / Current Initiative",
    "role": "CMS and AI Content Architect",
    "impact": "Combined deep CMS experience with new-gen GenAI thinking to shape content systems that improve creation velocity, editorial usability, and downstream digital consumption.",
    "metrics": {
      "ownership": "End-to-end",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "AI-ready"
    },
    "overview": "Built on extensive CMS and WordPress leadership by defining AI-enabled content workflows, modern editorial tooling, and integration-ready publishing architecture.",
    "scaleComplexity": "Enterprise editorial environments with numerous users, workflow dependencies, and digital publishing expectations.",
    "architectureTech": "",
    "tech": [
      "WordPress",
      "custom CMS architecture",
      "REST APIs",
      "AI content assistance concepts",
      "editorial workflow systems",
      "AWS-hosted publishing patterns"
    ],
    "outcomes": [
      "Merged legacy CMS modernization thinking with practical AI-assisted editorial opportunities.",
      "Designed content operations around usability for editors and extensibility for product teams.",
      "Applied deep WordPress experience to enterprise-grade publishing expectations.",
      "Framed CMS as a strategic platform, not a commodity implementation. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "AI-assisted publishing, API-ready CMS, workflow-centric content platforms.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "smart-city---iot-telemetry-and-real-time-dashboarding-platform",
    "title": "Smart City / IoT Telemetry and Real-Time Dashboarding Platform",
    "shortDesc": "Smart City / IoT Telemetry and Real-Time Dashboarding Platform",
    "programType": "Delivered Program",
    "role": "Cloud and Data Platform Architect",
    "impact": "Designed real-time telemetry ingestion and dashboarding patterns for smart-city-style environments requiring multi-tenant visibility and time-series operational insight.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Deep",
      "modernTech": "Cloud-native"
    },
    "overview": "Architected a telemetry platform for ingesting IoT data, organizing time-series insights, and driving real-time dashboards with multi-tenant operational controls.",
    "scaleComplexity": "High-frequency telemetry and operations visibility patterns suited for smart environments and infrastructure programs.",
    "architectureTech": "",
    "tech": [
      "Kafka/event ingestion patterns",
      "time-series databases",
      "cloud dashboards",
      "APIs",
      "multi-tenant controls",
      "data processing services"
    ],
    "outcomes": [
      "Defined ingestion patterns for continuous telemetry and dashboard-ready data flow.",
      "Designed time-series oriented storage and consumption logic.",
      "Balanced real-time visibility with tenant-aware operational control models.",
      "Used architecture patterns aligned to large-scale connected environments. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "IoT telemetry pipelines, time-series analytics, multi-tenant operational dashboards.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 100,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "ai-research-orchestrator",
    "title": "AI Research Orchestrator",
    "shortDesc": "Multi-Agent Knowledge Workflow",
    "programType": "Showcase / Current Initiative",
    "role": "AI Systems Architect",
    "impact": "Created a multi-agent research workflow concept that automates collection, summarization, synthesis, and structured output generation for knowledge-heavy tasks.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Growing",
      "architecture": "Advanced",
      "modernTech": "Cutting edge"
    },
    "overview": "Designed an AI research orchestrator where specialized agents handle collection, summarization, synthesis, and output assembly to accelerate complex information workflows.",
    "scaleComplexity": "Knowledge-work acceleration use cases rather than consumer-scale transaction systems.",
    "architectureTech": "",
    "tech": [
      "LLM agents",
      "orchestration patterns",
      "Python",
      "workflow logic",
      "summarization pipelines",
      "structured output design"
    ],
    "outcomes": [
      "Separated roles for information gathering, compression, synthesis, and final output generation.",
      "Focused on modular agent behavior instead of monolithic prompt chains.",
      "Created a reusable orchestration pattern for future knowledge automation ideas.",
      "Used the initiative to showcase applied understanding of agentic system design. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Multi-agent AI, workflow automation, structured knowledge synthesis.",
    "radar": [
      {
        "subject": "Scale",
        "A": 80,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 100,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  },
  {
    "id": "cloud-monitoring-and-observability-platform",
    "title": "Cloud Monitoring and Observability Platform",
    "shortDesc": "Cloud Monitoring and Observability Platform",
    "programType": "Delivered / Platform Practice",
    "role": "Cloud Architect / Observability Lead",
    "impact": "Defined monitoring and visibility architecture to give operations teams actionable dashboards, alerting, and cross-stack visibility beyond cloud-provider-native basics.",
    "metrics": {
      "ownership": "Primary",
      "scale": "Large",
      "architecture": "Advanced",
      "modernTech": "AI-ready"
    },
    "overview": "Architected an open-source-oriented monitoring and observability model for cloud infrastructure with dashboards, metrics, logs, and alerting visibility.",
    "scaleComplexity": "Cross-application and cross-infrastructure operational visibility for multi-component environments.",
    "architectureTech": "",
    "tech": [
      "Prometheus",
      "Grafana",
      "ELK/OpenSearch",
      "OpenTelemetry concepts",
      "AWS infrastructure monitoring patterns"
    ],
    "outcomes": [
      "Designed observability around decision-making needs, not only raw metric collection.",
      "Aligned dashboards and alerts to operational troubleshooting realities.",
      "Integrated metrics, logs, and visibility concepts into broader platform thinking.",
      "Positioned monitoring as a strategic reliability capability rather than an afterthought. | Business outcome & hiring signal"
    ],
    "businessOutcome": "",
    "trendingTechLens": "Observability engineering, open monitoring stacks, telemetry-driven operations.",
    "radar": [
      {
        "subject": "Scale",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Ownership",
        "A": 85,
        "fullMark": 100
      },
      {
        "subject": "Modern",
        "A": 90,
        "fullMark": 100
      },
      {
        "subject": "Impact",
        "A": 95,
        "fullMark": 100
      },
      {
        "subject": "Arch",
        "A": 85,
        "fullMark": 100
      }
    ]
  }
];
